const ChevronRightIcon = ({className, ...props}: React.SVGProps<SVGSVGElement>) => (
  <svg
  {...props}
  fill="#437EF7"
  xmlns="http://www.w3.org/2000/svg"
  width={8}
  height={14}
  className={`hover:fill-white ${className}`}
  >
    <path
      d="M5.586 7 .293 12.293a1 1 0 1 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414l-6-6A1 1 0 0 0 .293 1.707L5.586 7Z"
    />
  </svg>
)
export default ChevronRightIcon
